import { Permissao } from "../interfaces/Permissao"
import { PermissaoField } from "../interfaces/PermissaoField"

export default function setPermissoes(fields: PermissaoField, idGrupoAcesso: number){
    const newPermissions: Permissao[] = []
    
    Object.keys(fields).forEach((key: string) => {
        newPermissions.push({
            operacao: {
                idGrupoAcesso,
                idModuloMenu: Number(key),
                tipo: fields[Number(key)] ? 'ativar' : 'desativar',
            },
            mensagem: ''
        })
    })

    return newPermissions
}
